import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const distributeClasses = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.DISTRIBUTE.DISTRIBUTE_CLASSES(),
    data
  );
};

export default distributeClasses;
